export default /^[a-z]{2}(-[A-Z]{2})?$/;
